<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <card header-classes="bg-transparent">

            <div class="card">
                <div class=" card-header">
                    <h2 class="card-title">Mid Term Physical Development</h2>
                </div>
                <div class="card-body">
                    <div class="form-inline text-center">
                        <select v-model="RegisteredTermIdVal" class="form-control ml-3"
                            :disabled="RegisteredTerms === null">
                            <option value="0">{{ RegisteredTerms === null ? '⏳ Loading...' : '- Select Registered Term-' }}</option>
                            <option v-for="item in RegisteredTerms" :key="item.registeredTermId"
                                v-bind:value="item.registeredTermId">
                                {{ item.schSession }} - {{ item.schTerm }}
                            </option>
                        </select>
                        <select v-model="ClassIdval" class="form-control ml-3" @change="getoptioninclassassigned()"
                            :disabled="classitems === null">
                            <option value="0">{{ classitems === null ? '⏳ Loading...' : '- Select Class -' }}</option>
                            <option v-for="item in classitems" :key="item.Id" v-bind:value="item.Id">
                                {{ item.Sch_Class }}
                            </option>
                        </select>
                        <select v-model="OptionIdval" class="form-control ml-3" @change="getarminclassassigned()"
                            :disabled="optionitems === null">
                            <option value="0">{{ optionitems === null ? '⏳ Loading...' : '- Select Option -' }}</option>
                            <option v-for="item in optionitems" :key="item.Id" v-bind:value="item.Id">
                                {{ item.ClassOption }}
                            </option>
                        </select>
                        <select v-model="ArmIdval" class="form-control ml-3"
                            @change="GetStudentForPhysicalDevelopment()" :disabled="armitems === null">
                            <option value="0">{{ armitems === null ? '⏳ Loading...' : '- Select Arm -' }}</option>
                            <option v-for="item in armitems" :key="item.Id" v-bind:value="item.Id">
                                {{ item.SectionName }}
                            </option>
                        </select>
                    </div>
                    <div class="table-responsive mt-2">
                        <table class="table table-borderless table-striped table-hover table-sm">
                            <thead>
                                <tr>
                                    <th>Admission Number</th>
                                    <th>Student Name</th>
                                    <th>Begining Weight</th>
                                    <th>Begining Height</th>
                                    <th>End Weight</th>
                                    <th>End Height</th>
                                    <th>Comment</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="student in studentPhysicalDevelopmentItem" :key="student.studentId">
                                    <td class="align-middle" data-label="Admission Number">{{ student.admNo }}</td>
                                    <td class="align-middle" data-label="Student Name">{{ student.studentName }}</td>

                                    <td class="align-middle" data-label="Begining Weight">
                                        <input type="number" class="form-control" :min="0"
                                            v-model.number="student.begWeight" />
                                    </td>
                                    <td class="align-middle" data-label="Begining Height">
                                        <input type="number" class="form-control" :min="0"
                                            v-model.number="student.begHeight" />
                                    </td>
                                    <td class="align-middle" data-label="End Weight">
                                        <input type="number" class="form-control" :min="0"
                                            v-model.number="student.endWeight" />
                                    </td>
                                    <td class="align-middle" data-label="End Height">
                                        <input type="number" class="form-control" :min="0"
                                            v-model.number="student.endHeight" />
                                    </td>
                                    <td class="align-middle" data-label="Comment">
                                        <input type="text" class="form-control" v-model="student.comment" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="text-center card-footer mb-3" v-if="studentPhysicalDevelopmentItem">
                        <button type="submit" class="btn btn-primary my-4" @click.prevent="submitdata">Submit</button>
                    </div>
                </div>
            </div>
        </card>
    </div>
</template>
<script>
import moment from 'moment'
import Alert from "@/mixins/Alert.mixins"
import CheckStaffUser from "@/mixins/CheckStaffUser.mixin"
import PageSpinner from "@/components/PageSpinner"
export default {
    name: 'FullTermPhysicalDevelopmentAssessment',
    mixins: [Alert, CheckStaffUser],
    components: {
        PageSpinner
    },
    data() {
        return {
            dataid: 1,
            ClassIdval: 0,
            OptionIdval: 0,
            ArmIdval: 0,
            RegisteredTermIdVal: 0,
            ConductIdval: 0,
            TimePresentval: '',
            Commentval: '',
            RegisteredTerms: null,
            classitems: null,
            optionitems: null,
            armitems: null,
            conducts: null,
            othersgrades: null,
            studentitems: null,
            studentPhysicalDevelopmentItem: null,
            process: 'N',
            onloader: 'none'
        }
    },
    methods: {
        submitdata() {

            const physicalDevelopmentList = (this.studentPhysicalDevelopmentItem || [])
                .filter(student => Number(student.begWeight) > 0 || Number(student.begHeight) > 0 || Number(student.endWeight) > 0 || Number(student.endHeight) > 0)
                .map(student => ({
                    StudentId: student.studentId,
                    BegWeight: student.begWeight,
                    BegHeight: student.begHeight,
                    EndWeight: student.endWeight,
                    EndHeight: student.endHeight,
                    Comment: student.comment
                }));

            if (physicalDevelopmentList.length === 0) {
                this.ShowAlertWarning('No records to submit', 'Only students with record > 0 will be submitted.');
                return;
            }

            // Check if all records have comments
            const missingComments = physicalDevelopmentList.some(student => !student.Comment || student.Comment.trim() === '');
            if (missingComments) {
                this.ShowAlertWarning('Missing Comments', 'All students must have a comment before submission.');
                return;
            }

            let sectionId = this.ArmIdval;
            let registeredTermId = this.RegisteredTermIdVal;
            let userdata = {
                sectionId,
                registeredTermId,
                physicalDevelopmentList
            }
            this.onloader = 'flex'
            this.$store.dispatch('PortalPhysicalDevelopment/CreatePhysicalDevelopmentMidTerm', userdata)
                .then((resp) => {
                    if (resp.responseCode !== "00") {
                        this.onloader = 'none'
                        this.ShowAlertError(resp.responseMessage, '');
                        return;
                    }
                    this.onloader = 'none'
                    this.ShowAlertSuccess("Submitted successfully", '');
                })
                .catch(err => {
                    this.onloader = 'none'
                    this.ShowAlertError(err.response.data, '');
                })
        },
        GetStudentForPhysicalDevelopment() {
            if (this.ArmIdval > 0 && this.RegisteredTermIdVal > 0) {
                let SectionId = this.ArmIdval;
                let RegisteredTermId = this.RegisteredTermIdVal;
                let ConductId = this.ConductIdval;
                let userdata = {
                    SectionId,
                    RegisteredTermId,
                    ConductId
                }
                this.onloader = 'flex'
                this.$store.dispatch('PortalPhysicalDevelopment/GetStudentForPhysicalDevelopment', userdata)
                    .then((resp) => {
                        if (resp.responseCode === "00") {
                            this.studentPhysicalDevelopmentItem = resp.data;
                        } else {
                            this.studentPhysicalDevelopmentItem = null;
                        }
                        this.onloader = 'none'
                    })
                    .catch(err => {
                        this.onloader = 'none'
                        this.ShowAlertError(err.response.data, '');
                    })
            }

        },
        GetPortalRegisteredTerm() {
            let userdata = {
                SearchValue: null,
                PageNumber: 1,
                PageSize: 100
            }
            this.SessionIdval = 0;
            this.onloader = "flex";
            this.$store
                .dispatch("PortalSchoolSessionTerm/GetPortalRegisteredTerm", userdata)
                .then((resp) => {
                    this.RegisteredTerms = resp.data;
                    this.onloader = "none";
                })
                .catch((err) => {
                    console.log(err);
                    this.onloader = "none";
                });
        },
        getclassinclassassigned() {
            this.classitems = null;
            this.studentitems = null;
            this.optionitems = null;
            this.armitems = null;
            this.ConductIdval = 0;
            this.studentPhysicalDevelopmentItem = null;
            this.ClassIdval = 0;
            this.onloader = 'flex'
            this.$store.dispatch('getclassinclassassigned')
                .then(resp => {
                    this.classitems = resp;
                    this.onloader = 'none';
                })
                .catch(err => {
                    this.onloader = 'none'
                    this.ShowAlertError(err.response.data, '');
                })
        },
        getoptioninclassassigned() {
            this.studentitems = null;
            this.optionitems = null;
            this.armitems = null;
            this.studentPhysicalDevelopmentItem = null;
            this.ConductIdval = 0;
            this.OptionIdval = 0;
            this.onloader = 'flex'
            let ClassId = this.ClassIdval;
            if (ClassId > 0) {
                this.$store.dispatch('getoptioninclassassigned', ClassId)
                    .then(resp => {
                        this.optionitems = resp;
                        this.onloader = 'none';
                    })
                    .catch(err => {
                        this.onloader = 'none'
                        this.ShowAlertError(err.response.data, '');
                    })
            }
        },
        getarminclassassigned() {
            this.studentitems = null;
            this.armitems = null;
            this.studentPhysicalDevelopmentItem = null;
            this.ConductIdval = 0;
            this.ArmIdval = 0;
            this.onloader = 'flex'
            let OptionId = this.OptionIdval;
            if (OptionId > 0) {
                this.$store.dispatch('getarminclassassigned', OptionId)
                    .then(resp => {
                        this.armitems = resp;
                        this.onloader = 'none';
                    })
                    .catch(err => {
                        this.onloader = 'none'
                        this.ShowAlertError(err.response.data, '');
                    })
            }
        },
        frontEndDateFormat(date) {
            return moment(date).format('YYYY-MM-DD');
        },
        backEndDateFormat(date) {
            return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
        },

    },
    mounted() {
        this.GetPortalRegisteredTerm();
        this.getclassinclassassigned();
    }
};
</script>

<style scoped>
/* Mobile-friendly table: stack rows as cards below 576px */
@media (max-width: 576px) {
    .table-responsive table thead {
        display: none;
    }

    .table-responsive table,
    .table-responsive table tbody,
    .table-responsive table tr,
    .table-responsive table td {
        display: block;
        width: 100%;
    }

    .table-responsive table tr {
        margin-bottom: 0.75rem;
        border: 1px solid rgba(0, 0, 0, 0.05);
        padding: 0.5rem;
        border-radius: 6px;
        background: #fff;
    }

    .table-responsive table td {
        padding: 0.25rem 0.5rem;
        text-align: right;
        position: relative;
    }

    .table-responsive table td::before {
        content: attr(data-label) ": ";
        float: left;
        font-weight: 600;
        text-transform: none;
        color: #495057;
    }

    .form-control,
    .form-control-sm {
        width: 100%;
    }
}
</style>
